<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item prop="title" label="称呼">
                       <el-select v-model="form.title" placeholder="请选择" clearable style="width:200px;">
                            <el-option
                                v-for="item in titles"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="identityCard" label="身份证">
                        <el-input v-model="form.identityCard" maxlength="50" style="width:200px;"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    export default {
        data(){
            return{
                visible: false,
                form:{
                    title:"",
                    identityCard:"",
                    userId:""
                },
                titles:[{
                    value: '爸爸',
                    label: '爸爸'
                },{
                    value: '妈妈',
                    label: '妈妈'
                },{
                    value: '爷爷',
                    label: '爷爷'
                },{
                    value: '奶奶',
                    label: '奶奶'
                }],
                rules: {
                    title: [
                        { required: true, message: '请输入称呼', trigger: 'blur' }
                    ],
                    identityCard: [
                        { required: true, message: '请输入身份证', trigger: 'blur' },
                        { validator: this.validID, trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        methods:{
            init(userId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.userId=userId;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 身份证验证
            async validID(rule,value,callback){
                let reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('身份证号码不正确'))
                }
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.familyAddUrl;
                        let data = {
                            title:this.form.title,
                            identityCard:this.form.identityCard,
                            userId:this.form.userId,
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData(this.form.userId);
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/sys/user/AddFamilly.vue